export default __webpack_public_path__ + "static/media/baby.42471034.svg";